import { DateTime } from '@ksyos/date-time';
import type { IPatient } from '../../common/interfaces/patient';
import { getDisplayName } from '../../common/utils/getDisplayName';

export function getHolterDiaryUrl(requestId: string, patient: IPatient) {
    const today = DateTime.now().format('DD-MM-YYYY');
    const patientName = getDisplayName(patient);
    const fileName = `Holter dagboek - ${today} - ${patientName}.pdf`;

    return `/api/makeHolterDiary/${requestId}/${encodeURIComponent(fileName)}`;
}
